import React from 'react';
import PropTypes from "prop-types";
import { Form } from "reactstrap";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import Loader from "../../../common/Loader";
import FormFooter from "../../../common/forms/FormFooter";
import BusChassisFormFields from './BusChassisFormField';

export const BusChassisForm = ({
  handleSubmit,
  loading,
  initialValues,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <BusChassisFormFields
        initialValues={initialValues}
      />
      <FormFooter />
    </Form>
  );
};

BusChassisForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({}),
};

BusChassisForm.defaultProps = {
  initialValues: null,
};

const mapStateToProps = (state) => ({
  loading: !state.BusUnit.BusChassis.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'BusChassisForm',
})(BusChassisForm);

export default connect(mapStateToProps)(formComponent);